import React from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import ProcedureDetails from './features/bd_procedures/components/ProcedureDetails'
import BDProceduresPage from './features/bd_procedures/pages/BDProceduresPage';
import OnBaseDeletedDocumentsPage from './features/onbasedocuments/pages/OnBaseDeletedDocumentsPage';
import OnBaseFailedDocumentsPage from './features/onbasedocuments/pages/OnBaseFailedDocumentsPage';
import ListSummaryPage from './features/ftp_automation/pages/ListSummaryPage';

type AppProps = {
  pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
  return (
      <MsalProvider instance={pca}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/BDProcedures" element={<BDProceduresPage />} />
          <Route path="/OnBaseDeletedDocuments" element={<OnBaseDeletedDocumentsPage />} />
          <Route path="/OnBaseFailedDocuments" element={<OnBaseFailedDocumentsPage />} />
          <Route path="/ProcedureDetails" element={<ProcedureDetails />} />
          <Route path="/FTPAutomationList" element={<ListSummaryPage />} />
        </Routes>
      </MsalProvider>
  );
}

export default App;